










































import Vue from 'vue';
import SAvatar from '../SAvatar/SAvatar.vue';

/**
 * A user avatar that opens a menu when clicked
 */
export default Vue.extend({
  name: 'SUser',
  components: {
    SAvatar,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    /**
     * Which side the menu should by default aligned to the toggle button. Will automagically swap
     * sides if there isn't enough space to render (only when being toggled open though).
     */
    defaultSide: {
      required: false,
      type: String,
      default: 'left',
    },
    /**
     * If the menu should be closed after clicking on an item in .s-user__content
     */
    closeOnContentClick: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      open: false,
      side: 'left',
    };
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    enter() {
      const {
        width,
        left,
        right,
      } = this.$refs.userContent.getBoundingClientRect();
      const lastX = this.side === 'left' ? left + width : right - width;

      if (lastX > window.innerWidth) {
        this.side = 'right';
        return;
      }

      if (lastX < 0) this.side = 'left';
    },
    afterLeave() {
      this.side = this.defaultSide;
    },
    /**
     * Handles closing the component
     */
    documentClick({ target }) {
      if (!this.open) {
        return;
      }
      const { sUser, userContent } = this.$refs;
      if (sUser == null || userContent == null) return;
      let el = target;

      const shouldLoopRun = () => (
        el !== sUser
          && el !== null // get null after getting parentElement of document root
          && (!this.closeOnContentClick
            || (this.closeOnContentClick && el !== userContent))
      );

      while (shouldLoopRun()) {
        el = el.parentElement;
      }

      /**
       * Click event happened inside SUser component and either
       * closeOnContentClick is false or the userContent wasn't clicked
       */
      if (el === sUser) {
        return;
      }

      /**
       * At this point either:
       *  - closeOnContentClick is true & userContent has been clicked
       *  - No element to do with sUser component has been clicked
       */
      this.open = false;
    },
  },
});
